"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegendItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LineIcon = require("./LineIcon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LegendItem = exports.LegendItem = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    checked = false,
    item,
    onMouseEnter,
    onMouseLeave,
    onCheck
  } = _ref;
  const labelId = "checkbox-list-secondary-label-".concat(item.id);
  return /*#__PURE__*/_react.default.createElement(_material.ListItem, {
    key: item.id,
    className: "listItem",
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    disablePadding: true,
    secondaryAction: /*#__PURE__*/_react.default.createElement(_paulCorePackage.Checkbox, {
      edge: "end",
      disableRipple: true,
      checked: checked,
      inputProps: {
        'aria-labelledby': labelId
      }
    })
  }, /*#__PURE__*/_react.default.createElement(_material.ListItemButton, {
    onClick: onCheck,
    dense: true,
    sx: {
      zIndex: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mr: 1
  }, /*#__PURE__*/_react.default.createElement(_LineIcon.LineIcon, {
    equipmentType: item.equipmentType,
    displayNameId: item.displayNameId,
    icon: item.icon
  })), /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
    id: labelId,
    sx: {
      paddingRight: 6
    },
    primary: item.title
  })));
}, (prev, next) => prev.checked === next.checked && _paulCorePackage.functions.areEqual(prev.item, next.item) && prev.onMouseEnter === next.onMouseEnter && prev.onMouseLeave === next.onMouseLeave && prev.onCheck === next.onCheck);
LegendItem.propTypes = {
  checked: _propTypes.default.bool,
  item: _propTypes.default.shape({
    id: _propTypes.default.string,
    equipmentType: _propTypes.default.string,
    title: _propTypes.default.string,
    displayNameId: _propTypes.default.string,
    icon: _propTypes.default.shape({
      type: _propTypes.default.oneOf(['gusty_line', 'line']),
      strokeDasharray: _propTypes.default.string
    })
  }),
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func,
  onCheck: _propTypes.default.func
};